export default "__VITE_ASSET__BEht8yhY__"